const globalDelay = 3000;

/**
 * Export results to pdf format
 *
 * @param object The button that triggers the action
 */
window.descargarEnPdf = function (object) {
    const count = $(object).attr('data-count');
    const url   = $(object).attr('data-url');
    let delay   = 0;
    if (!count || count > maxExportPdfElements) {
        pNotifyWarning(transFicheroErrorsMaxElementsToExportPdf);
        delay = globalDelay;
    }
    setTimeout(function () {
        window.open(url, '_blank');
    }, delay);
}

/**
 * Export results to excel format
 *
 * @param object The button that triggers the action
 */
window.descargarEnExcel = function (object) {
    const count = $(object).attr('data-count');
    const url   = $(object).attr('data-url');
    let delay   = 0;
    if (!count || count > maxExportExcelElements) {
        pNotifyWarning(transFicheroErrorsMaxElementsToExportExcel);
        delay = globalDelay;
    }
    setTimeout(function () {
        window.open(url, '_blank');
    }, delay);
}
